import React, { useState } from "react";
import { useParams } from "react-router-dom";
import styled from 'styled-components';
import ReactPlayer from 'react-player/youtube';


import getImages from '../lib/getImages';
import Navigation from "../components/Navigation";
import Blad from './../images/blad.jpg';
import Logos from "./../components/Logos";
import SEO from "./../components/SEO";

import artistInfo from "./../lib/artistInfo";
import Pdf from '../Documents/KONSERTMENY.pdf';
import { useLanguage } from "../i18n";

const NavHolder = styled.div`
  @media screen and (min-width: 501px) {
    margin-left: 2.%;
    margin-right: 2%;
  }
  @media screen and (min-width: 600px) {
    margin-left: 5%;
    margin-right: 5%;
  }
  @media screen and (min-width: 800px) {
    margin-left: 8%;
    margin-right: 8%;
  }
`;

const Main = styled.main`
  margin: 0.5rem auto;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 0;
`;

const Article = styled.article`

  width: 100%;
  margin: 0;

  ul {
      list-style: none;
      font-style: italic;
  }

  @media screen and (min-width: 501px) {
    width: 95%;
  }
  @media screen and (min-width: 600px) {
    width: 85%;
  }
  @media screen and (min-width: 800px) {
    width: 80%;
  }
`;

const Datum = styled.div`
  text-transform: uppercase;
  font-size: 1.6rem;
  font-weight: 600;
  margin: 1.5rem 0 0 0;
  line-height: 1.8rem;
  text-align: center;
`;

const Header = styled.header`
  width: 100%;
  display: grid;
  grid-template-rows: 1fr 60px;
  grid-template-columns: 1fr;

  img {
    width: 100%;
    grid-column-start: 1;
    grid-row: 1 / 3;
  }
`;

const EvenemangBg = styled.div`
  background-color: #002;
  opacity: 0.7;
  grid-row: 2 / 3;
  grid-column-start: 1;
  z-index: 1;
`;

const Evenemang = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  grid-row-start: 2;
  grid-row-end: 3;
  grid-column-start: 1;
  z-index: 2;

    h1 {
      font-family: 'nunito', serif;
      font-weight: 400;
      font-size: 1.8rem;
      line-height: 2rem;
      text-transform: uppercase;
      color: #eee;
      text-align: center;
    }
`;

const Buy = styled.button`
  display: block;
  padding: 0.5rem 0.8rem 0.4rem 0.8rem;
  border-radius: 25px;
  background-image: linear-gradient(-180deg, #FF7E31, #E62C03);
  color: #fff;
  box-shadow: rgba(0, 0, 0, 0.4) 0 3px 5px;
  transition: box-shadow .2s;
  margin: 1rem auto 2rem auto;

  :hover {
    cursor: pointer;
    box-shadow: rgba(253, 76, 0, 0.5) 0 3px 8px;
  }
  :active {
    box-shadow: rgba(253, 76, 0, 0.9) 0 2px 4px;
  }
`;

const Text = styled.div`
  margin: 0 1rem;
`;

const BasInfo = styled.aside`
  padding: 1.2rem 1rem 1rem 0.8rem;
  border: double #999 3px;
  border-radius: 10px;
  margin: 1.5rem auto;
  max-width: 800px;
  text-align: center;
  font-size: 0.9rem;
  background-image: url(${Blad});
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 18%;

  h4 {
    margin: 0 0 0.2rem 0;
  }

  @media screen and (min-width: 520px) {
    margin: 1.5rem auto;
  }

`;

const Pris = styled.p`
  margin-top: 2rem;
`

const Authors = styled.div`
  padding: 1.2rem 1rem 1rem 0.8rem;
  border: double #999 3px;
  border-radius: 10px;
  margin: 1.5rem auto;
  max-width: 800px;
  text-align: center;
  font-size: 0.9rem;
  background-image: url(${Blad});
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 18%;

  h4 {
    margin: 0 0 0.2rem 0;
  }

  @media screen and (min-width: 520px) {
    margin: 1.5rem auto;
  }
`;

const Fotograf = styled.div`
  position: absolute;
  bottom: 0;
  right: 10px;
  color: white;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
`;

const Viktigt = styled.div`
  position: absolute;
  top: 300px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  transform: rotate(-33deg);
  font-size: 3em;
  font-weight: bold;
  color: red;
  text-align: center;
  z-index: 99;

  @media screen and (min-width: 520px) {
    top: 320px;
    font-size: 3.5em;
  }

  @media screen and (min-width: 600px) {
    top: 330px;
    font-size: 3.5em;
  }

  @media screen and (min-width: 700px) {
    top: 400px;
    font-size: 3.5em;
  }

  @media screen and (min-width: 800px) {
    top: 450px;
    font-size: 4em;
  }

  @media screen and (min-width: 1000px) {
    top: 530px;
    font-size: 5em;
  }
`;

const ViktigText = styled.div`
  text-align: center;
  margin-top: 1rem;
`;

const Medlemskap = styled.div`
  margin: 1rem 2rem;
`;

let m;
let d;
let dag;

const Event = () => {

  let { id } = useParams();
  const { lang, t } = useLanguage();

  const months = t('months');
  const weekdays = t('weekdays');

  const event = artistInfo.filter(obj => obj.id === Number(id))[0];

  [, m, d] = event['datum'].split("-");
  dag = new Date(event['datum']);

  // Use language-specific content if available, fallback to Swedish
  const Presentation = event[`info_${lang}`] || event['info'];
  const Artist = event[`namn_${lang}`] || event['namn'];

  const biljett_id = event['biljett_id'];
  const video = event['video'];
  const videonamn = event['videonamn'];

  const Namn = function () {
    return (
      <h1><Artist /></h1>
    )
  }

  const [purchase, setPurchase] = useState(false);
  function buyTicket() {
    setPurchase(true);
  }
  purchase && window.location.replace('https://nortic.se/ticket/event//' + biljett_id);

  return (
    <>
      <SEO pageKey="event" />
      <NavHolder>
        <Navigation page={'stage'} />
      </NavHolder>
      <Main>
        <Article>
          <Header>
            <img src={getImages[event['img'] + '.jpg']} alt="event" />
            {
              event['slutsålt'] && <Viktigt>{t('event.soldOut')}</Viktigt>
            }
            {
              event['inställt'] && <Viktigt>{t('event.cancelled')}</Viktigt>
            }
            <EvenemangBg />

            <Evenemang>
              <Namn />
              {event['foto'] ? <Fotograf>{t('event.photo')}: {event['foto']}</Fotograf> : null}
            </Evenemang>

          </Header>
          <Text>


            <Datum>{event['konst'] && t('event.vernissage') + " "} {weekdays[dag.getDay()]} {parseInt(d, 10)} {months[parseInt(m)]} <nobr>{event['tid']}</nobr></Datum>

            {
              event['pris'] !== 0 && event['inställt'] ? <ViktigText>{t('event.cancelledMessage')}</ViktigText> :
                event['pris'] !== 0 && event['slutsålt'] ? <ViktigText>{t('event.soldOutMessage')}</ViktigText> :
                  event['pris'] < 2 ? "" : <Buy type='button' onClick={buyTicket}>{t('event.buyTicket')}</Buy>
            }

            <Presentation />

            {
              event['youtube'] && <p><ReactPlayer url={event['youtube']} playbackRate={1} /></p>
            }

            {
              event['youtube2'] && <p><ReactPlayer url={event['youtube2']} playbackRate={1} /></p>
            }

            {
              video && <p>Video: <a href={video} rel="noreferrer" target="_blank">{videonamn}</a></p>
            }

            <Pris>
              {
                event['pris'] === 0 ? t('event.freeEntry') : event['pris'] === 1 ? "" : t('event.ticketPrice') + ": " + event['pris'] +
                  " KR. " + t('event.memberPrice') + ": " + Math.floor(event['pris'] - event['pris'] * 0.15) + " KR. " + t('event.serviceFee')
              }
              <br /><br />


            </Pris>

            {
              event['standardmeny'] && <p>
                {t('event.cafeOpens')}
                <br /><br />
                {t('event.standardMenuInfo')}
                <br /><br />
                {t('event.kitchenCloses')}
                <br /><br />
                {t('event.freeSeating')}
              </p>
            }

            {
              event['konsertmeny'] && <p>
                {t('event.cafeOpens')}<br /><br />

                {t('event.concertMenuInfo')} <a rel="noreferrer" href={/konsertmat/} target="_blank">{t('event.concertMenuLink')}</a>.
                <br />
                {t('event.concertMenuPreorder')}

                <br /><br />
                {t('event.drinksAvailable')}<br /><br />
                {t('event.fullLicense')}
                <br /><br />
              </p>

            }

            {
              event['music'] ? <BasInfo>

                <h4>{t('event.musicOnKrogbacken')}</h4> {t('event.organizedBy')} <nobr>{t('event.kulturPaKrogbacken')}</nobr>.
                <Medlemskap>{t('event.becomeMember')} <a href='https://member.myclub.se/public/forms/13519/LUgeoOuwSL/'>{t('event.memberForm')}</a>.</Medlemskap>
                {t('event.sponsorThanks')}

                <Logos />

              </BasInfo> :
                event['konst'] ? <p></p> :
                  event['tonkonst'] ? <p></p> :
                    event['author'] ?
                      <Authors>
                        <h4>{t('event.authorTuesdays')}</h4>
                        <p>
                          {t('event.authorWelcome')}
                        </p>
                        <p>
                          {t('event.authorSummer')}<br />
                          {t('event.authorTell')}
                        </p>
                        <p>{t('event.authorOrganized')}</p>
                        <Medlemskap>{t('event.becomeMemberAuthor')} <a href='https://member.myclub.se/public/forms/13519/LUgeoOuwSL/'>{t('event.memberForm')}</a>.</Medlemskap>
                        <p>
                          {t('event.warmWelcome')}
                        </p>

                      </Authors> : ""
            }

          </Text>
        </Article>
      </Main>
    </>

  );
}

export default Event;
